import { ACL_TYPE } from '@openx/types/aclType.ts';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators.ts';

export function useCanCreateAmazonMarketplaceDeal(): boolean {
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  return isAllowed(isAllowedByCompiledAcl(ACL_TYPE.DEAL_AMAZON_MARKETPLACE_ENABLED));
}
